import { useState, useEffect } from "react";
import css from "./CustomTabs.module.css";

const CustomTabs = ({ tabs, defaultTab = 0 }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  // Update activeTab when defaultTab changes (e.g., from URL params)
  useEffect(() => {
    setActiveTab(defaultTab);
  }, [defaultTab]);

  return (
    <div className={css.tabs_container}>
      <div className={css.tabs}>
        {tabs.map((tab, i) => (
          <button
            key={i}
            className={`${css.tab_button} ${
              activeTab === i ? css.active : ""
            } ${i !== 0 && i !== tabs.length - 1 ? css.middle_tab : ""}`}
            onClick={() => setActiveTab(i)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="tab_content">{tabs[activeTab].content}</div>
    </div>
  );
};

export default CustomTabs;
